import React, { useEffect } from 'react';
import * as d3 from "d3";
import Ranges from './chart/ranges';
import Genome from './chart/genome';
import Chromosome from './chart/chromosome';

function Chart (props){
    
    const [update, setUpdate] = React.useState(false);
    const [resolution, setResolution] = React.useState(200);
    
    const dataset = props.data,
        biobanks = props.biobanks,
        types = props.types,
        dna = props.dna || [],
        pos = props.pos,
        chr = props.chr,
        topView = props.topView,
        setTopView = props.setTopView,
        width = props.width,
        settings = props.settings,
        ranges = props.ranges,
        setRanges = props.setRanges,
        setLocus = props.setLocus,
        slot = props.slot,
        setSlot = props.setSlot,
        defineMinPval = props.defineMinPval,
        format = props.format;

    const size = {
        margin:{ 
            top: 40,
            left: 255,
            gutter: 6,
            bottom: 6,
        },
        width: width,
        height: 60,
    };

    function enableChangeChr (direction, hide, cancel, able) {
        if (topView[1] === 'gnm') return hide
        else if (direction === 'back' && topView[2] === 0) return cancel
        else if (direction === 'forth' && topView[2] === 22) return cancel
        else return able
    }

    function changeRanges (newRanges) {
        setRanges(newRanges)
        setUpdate(!update)
    };

    function drawLines (data) {
        d3.select('#lines01').select('#linesHorizontal')
            .selectAll(".thickLine")
            .data(data)
            .join("line")
                .attr('id', (d,i)=>'line_chr'+(i+1))
                .attr("y1", size.margin.top)
                .attr("y2", size.margin.top)
                .classed("thickLine", true)
                .transition()
                    .style('opacity', 0)
                    .attr("x1", d=>d[0])
                    .attr("x2", d=>d[1])
                .transition()
                    .style('opacity', 1)
        
        // d3.select('#background01')
        //     .selectAll('rect')
        //     .data(data)
        //     .join('rect')
        //         .attr('x', d => d[0])
        //         .attr('y', size.margin.top)
        //         .attr('width', d => d[1]-d[0])
        //         .attr('height', biobanks.length * size.height)
        //         .attr('fill', settings.blue0)
        //         .style('transition', 'none')

        d3.select('#chrTitles')
            .selectAll(".smallText")
            .data(data)
            .join("text")
                .classed("smallText",true)
                .attr("y", size.margin.top-10)
                .style("text-anchor", "start")
                .transition()
                    .style('opacity', 0)
                    .text((d,i)=> topView[1] === 'chr' ? topView[2]+1 : i+1)
                    .attr("x", d=>d[0])
                .transition()
                    .style('opacity', 1)
    }

    function updateView (action, value) {
        d3.selectAll('#view02, #view03, #slotCircle01').transition().duration(500).style('opacity', 0);
        setTimeout(operate, 500)

        function operate() {
            setSlot({})
            setLocus({});

            if (action === 'resolution') setResolution(value)
            else if (action === 'genome' ) setTopView(['cht', 'gnm']);
            else if (action === 'chromosome') setTopView(['cht', 'chr', topView[2]+1*value]);
        }
    }

    d3.select('#chart').transition().duration(500).style('opacity',1);

    useEffect(()=>{
    })

    return (
        <div id="chart" className="section">
            <div className="section_header">
                <h1>{topView[1] === 'gnm' ? 'Genome view' : 'Chromosome view'}</h1>
                <div className="section_header_buttons" style={{width: size.width-size.margin.left}}>
                    <div style={{display: 'flex'}}>
                        <form>
                            <input 
                                id='b_resolution'
                                style={{width: 60, textAlign: 'start', marginLeft: 0}}
                                type="number"
                                min={10}
                                max={1001}
                                placeholder={resolution}
                            />
                        </form>
                        <button onClick={()=>updateView('resolution', document.getElementById("b_resolution").value)}>Change resolution</button>
                    </div>
                    <div>
                        <button style={{opacity: topView[1] === 'chr' ? 1 : 0, pointerEvents: topView[1] === 'chr' ? 'auto' : 'none'}} onClick={() => updateView('genome')}>Back to Genome view</button>
                        <button style={{opacity: enableChangeChr('back', 0, 0.2, 1), pointerEvents: enableChangeChr('back', 'none', 'none', 'auto')}} onClick={() => updateView('chromosome', -1)}>&#8249;</button>
                        <button style={{opacity: enableChangeChr('forth', 0, 0.2, 1), pointerEvents: enableChangeChr('forth', 'none', 'none', 'auto')}} onClick={() => updateView('chromosome', +1)}>&#8250;</button>
                    </div>
                </div>

            </div>
            <div className="section_content">
                <svg id="chart01" style={{width: size.width, height: biobanks.length * size.height + size.margin.top + size.margin.bottom}}>
                    <g id="title01">
                        <text x={0} y={size.margin.top-25} className='smallText'>Tracks and P-value coloring</text>
                        <text x={0} y={size.margin.top-10} className='smallText'>log(P-value)</text>
                        <text x={size.margin.left} y={size.margin.top-25}  className='smallText' id="chromosome">Chromosome</text>
                        <g id="chrTitles"></g>
                    </g>
                    {/* <g id="background01"></g> */}
                    <g id="thumbnail01"></g>
                    <g id="lines01">
                        <line className="thickLine" x1={0} x2={size.margin.left-size.margin.gutter} y1={size.margin.top} y2={size.margin.top}/>
                        <g id="linesHorizontal"></g>
                    </g>
                    <g id="position01">
                        <line className="hoverLine" id="hoverLine01" style={{display:"none"}} y1={size.margin.top} y2={props?.biobanks.length*size.height+size.margin.top} />
                        <circle id="slotCircle01" style={{opacity: '0'}} r={3} cy={size.margin.top+biobanks.length*size.height+3} fill={settings.pink0}></circle>
                    </g>
                    <g id="ranges">
                        <Ranges
                            ranges={ranges}
                            setRanges={changeRanges}
                            setLocus={setLocus}
                            size={size}
                            title={biobanks}
                            settings={settings}
                            setSlot={setSlot}
                            format={format}
                            types={types}
                        />
                    </g>
                    <Genome 
                        dataset={dataset}
                        biobanks={biobanks}
                        types={types}
                        dna={dna}
                        pos={pos}
                        settings={settings}
                        topView={topView}
                        setTopView={setTopView}
                        ranges={ranges}
                        size={size}
                        resolution={resolution}
                        defineMinPval={defineMinPval}
                        drawLines={drawLines}
                    />
                    <Chromosome
                        dataset={topView[2] ? dataset.filter(el => el[0] === (topView[2]+1))[0][1] : []}
                        biobanks={biobanks}
                        types={types}
                        dna={dna}
                        pos={pos}
                        chr={chr}
                        topView={topView}
                        settings={settings}
                        ranges={ranges}
                        size={size}
                        resolution={resolution}
                        defineMinPval={defineMinPval}
                        drawLines={drawLines}
                        setSlot={setSlot}
                        setLocus={setLocus}
                    />
                </svg>
            </div>
        </div> 
        )
}
export default Chart;